/* eslint-disable @typescript-eslint/naming-convention */
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useSubscription } from "@apollo/client";
import { useSelector } from "react-redux";
import NOTIFICATION_FOUND from "src/graphql/subscriptions/chat/notificationFound";
import useAuth from "src/hooks/useAuth";
import useSubscriptionCondition from "./subscriptionCondition";
import ScreenLoader from "./screenLoader";

const AuthGuard = () => {
  const { loading, isAuthenticated } = useAuth() as any;
  const { me }: any = useSelector((state: any) => state.me);

  const { pathname } = useLocation();

  const { panelType } = useActiveUserDetail();

  const redirecToSubscription = useSubscriptionCondition();

  useSubscription(NOTIFICATION_FOUND);

  if (loading) return <ScreenLoader />;

  // 🔒 Enforce billingOnly isolation
  if (me?.billingOnly) {
    // if (pathname !== "/settings/billing") {
    const allowedBillingPaths = ["/settings/billing", "/settings/upgrade-plan"];
    if (!allowedBillingPaths.includes(pathname)) {
      return <Navigate to="/settings/billing" replace />;
    }
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
  }

  if (redirecToSubscription) {
    return <Navigate to="/subscription" />;
  }

  const restrictedPaths = [
    "/settings/facebook",
    "/settings/instagram",
    "/settings/whatsapp",
    "/settings/twilio",
    "/settings/upgrade-plan",
    "/settings/billing",
    "/settings/chatbot-widgets",
  ];
  // Redirect if the user is unauthenticated or not a SUPERADMIN trying to access restricted paths
  if (
    isAuthenticated &&
    panelType !== "SUPERADMIN" &&
    restrictedPaths.includes(pathname)
  ) {
    return <Navigate to="/settings" />;
  }

  // const restrictedChannels = ["/settings/instagram", "/settings/whatsapp"];
  // if (
  //   isAuthenticated &&
  //   me?.plans?.toLowerCase() === "basic" &&
  //   restrictedChannels.includes(pathname)
  // ) {
  //   return <Navigate to="/settings/facebook" />;
  // }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthGuard;
